import { Injectable } from '@angular/core';
import { MenuSections, ViewType } from '@thehubz/client/core';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { AssetViewTypeService } from '../../../services/asset-view-type.service';
import { MenuSettingsData } from '../../assets/menu-settings-data';

@Injectable()
export class AssetRelationsService {
  private _showWheelMenu = new BehaviorSubject<boolean>(false);
  showWheelMenu$ = this._showWheelMenu.asObservable();

  private _changeViewTypeClicked = new BehaviorSubject<ViewType>('grid_4');
  changeViewTypeClicked$ = this._changeViewTypeClicked.asObservable();

  private _menuObject = new BehaviorSubject<MenuSections[]>(MenuSettingsData.ASSET_MENU_SETTINGS);

  menuObject$ = this._menuObject.asObservable();

  _selectedViewType = new BehaviorSubject<ViewType>('grid_4');
  selectedViewType$ = this._selectedViewType.asObservable();

  vm$ = combineLatest([this.showWheelMenu$, this.menuObject$, this.selectedViewType$]).pipe(
    map(([showWheelMenu, menuObject, selectedViewType]) => ({
      showWheelMenu,
      menuObject,
      selectedViewType,
    })),
  );

  constructor(private assetViewTypeService: AssetViewTypeService) {
    const gridSize = this.assetViewTypeService.getGridConfig('RelationsTab').gridSize || 4;
    const gridViewType = `grid_${gridSize}` as ViewType;
    this._changeViewTypeClicked.next(gridViewType);
    this._selectedViewType.next(gridViewType);
  }

  /**
   * Called from wheel menu component when a menu item is clicked.
   * @param viewType
   */
  changeViewType(viewType: ViewType) {
    this._changeViewTypeClicked.next(viewType);
    this._selectedViewType.next(viewType);
  }

  showWheelMenu(show: boolean) {
    this._showWheelMenu.next(show);
  }
}
